module.exports = __webpack_public_path__ + "media/src/assets/logo-7eb3a55bb9dfb0f7b98dfb6ade3aae06.png";